import { render, staticRenderFns } from "./Registered.Courses.vue?vue&type=template&id=3688b1be"
import script from "./Registered.Courses.vue?vue&type=script&lang=js"
export * from "./Registered.Courses.vue?vue&type=script&lang=js"
import style0 from "./Registered.Courses.vue?vue&type=style&index=0&id=3688b1be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports